// extracted by mini-css-extract-plugin
export default {"year":"_NR9ntjnZymNVxkeFUiw","active":"xmh53CatbrZhvIl7QPpD","current":"IG3NNE8qb9OGDZ5rWxkp","month":"V92aw6lca5Q_4zytJvQI","placeHolderShimmer":"Mv5FZQ7XZd4gt1dnBBf_"};